import { gql } from "@apollo/client";

const UPDATE_DONOR_PANEL = gql`
mutation UpdateDonorPanel($mainFundingAccountId: ID, $productId: ID, $userId: ID!, $userArgs: CombinedUpdateUserInput!) {
  updateDonorPanel(mainFundingAccountId: $mainFundingAccountId, productId: $productId, userId: $userId, userArgs: $userArgs)
}`;

const UPDATE_ADVISOR_PANEL = gql`
mutation UpdateAdvisorPanel($userId: ID!, $userArgs: CombinedUpdateUserInput!, $userEntityActionType: String!, $userEntityId: ID, $userEntityArgs: UpdateUserEntityInput) {
  updateAdvisorPanel(userId: $userId, userArgs: $userArgs, userEntityActionType: $userEntityActionType, userEntityId: $userEntityId, userEntityArgs: $userEntityArgs)
}`;

const CALCULATE_AUM_METRICS = gql`
mutation CalculateAumMetrics {
  calculateAumMetrics
}`;

const UPDATE_SALESFORCE_CRDS = gql`
mutation UpdateSalesforceCrds {
  updateSalesforceCrds
}`;

export { UPDATE_ADVISOR_PANEL, UPDATE_DONOR_PANEL, CALCULATE_AUM_METRICS, UPDATE_SALESFORCE_CRDS };